<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>For Jude Fawley; for Ida, who shares his vision; for Annie, who didn’t.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587664_oeb_ded_r1.vue?0c7bc72f